<!-- Bouton flottant -->
<button class="chat-fab" [class.chat-fab--hidden-mobile]="isOpen" (click)="toggle()" [attr.aria-label]="'Assistant'">
  <i class="fas" [class.fa-comments]="!isOpen" [class.fa-times]="isOpen"></i>
</button>

<!-- Panneau de conversation -->
@if (isOpen) {
  <div class="chat-panel">

    <div class="chat-header">
      <span class="chat-header-title">
        <i class="fas fa-robot mr-1"></i>
        {{ 'CHAT_WIDGET_TITLE' | translate }}
      </span>
      <button class="chat-close-btn" (click)="close()">✕</button>
    </div>

    <div class="chat-messages" #messagesContainer>
      <div class="chat-messages-spacer"></div>
      @for (msg of messages; track $index) {
        <div class="chat-bubble"
             [class.chat-bubble--user]="msg.role === 'user'"
             [class.chat-bubble--model]="msg.role === 'model'">
          @if (msg.role === 'model') {
            <span [innerHTML]="msg.text | chatMarkdown"></span>
          } @else {
            {{ msg.text }}
          }
        </div>
      }

      @if (isLoading) {
        <div class="chat-bubble chat-bubble--model chat-bubble--typing">
          <span class="typing-dot"></span>
          <span class="typing-dot"></span>
          <span class="typing-dot"></span>
        </div>
      }
    </div>

    <!-- Suggestions rapides (visibles uniquement avant le 1er message utilisateur) -->
    @if (showSuggestions && !isLoading) {
      <div class="chat-suggestions">
        @for (s of suggestions; track s.labelFr) {
          <button class="chat-suggestion-chip" (click)="pickSuggestion(s)">
            {{ suggestionLabel(s) }}
          </button>
        }
      </div>
    }

    <div class="chat-input-row">
      <textarea
        class="chat-input"
        [(ngModel)]="userInput"
        (keydown)="onKeydown($event)"
        [placeholder]="'CHAT_WIDGET_PLACEHOLDER' | translate"
        rows="1"
        [disabled]="isLoading">
      </textarea>
      <button class="chat-send-btn" [disabled]="!userInput.trim() || isLoading" (click)="send()">
        <i class="fas fa-paper-plane"></i>
      </button>
    </div>

  </div>
}
